import React, { useEffect } from 'react'
import { ConsentManager, openConsentManager } from '@segment/consent-manager'
import inEU from '@segment/in-eu'

export const JourneyConsentManager = () => {
  const bannerContent = (
    <span>
      We use cookies (and other similar technologies) to collect data to improve your experience on
      our site. Visit our <a href="https://www.journey.io/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> to learn more.
    </span>
  )
  const preferencesDialogTitle = 'Website Data Collection Preferences'
  const preferencesDialogContent =
    'We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.'
  const cancelDialogTitle = 'Are you sure you want to cancel?'
  const cancelDialogContent =
    'Your preferences have not been saved. By continuing to use our website, you՚re agreeing to our Website Data Collection Policy.'


  useEffect(() => {
    if (!inEU() && process.env.SEGMENT_PLAYER_WRITE_KEY) {
      window.analytics && window.analytics.load && window.analytics.load(process.env.SEGMENT_PLAYER_WRITE_KEY);
    }
  }, []);

  if (!process.env.SEGMENT_PLAYER_WRITE_KEY) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[1000000]">
      <ConsentManager
        writeKey={process.env.SEGMENT_PLAYER_WRITE_KEY}
        shouldRequireConsent={inEU}
        bannerContent={bannerContent}
        bannerBackgroundColor='#066370'
        bannerActionsBlock={true}
        preferencesDialogTitle={preferencesDialogTitle}
        preferencesDialogContent={preferencesDialogContent}
        cancelDialogTitle={cancelDialogTitle}
        cancelDialogContent={cancelDialogContent}
      />
    </div>
  )
}